<template>
  <div v-if="egress_profile">
    <AchievementRangeGroupSelector
      class="mt-2"
      :egress_profile_id="egress_profile.id"
      @selected_range_group="selectedRangeGroup"
    ></AchievementRangeGroupSelector>
    <AssessmentGroupStudyUnitTable
      :key="selected_achievement_range_group"
      :egress_profile="egress_profile"
      :egress_profile_matter="egress_profile_matter"
      :cohorts_="cohorts_"
      :cohort_indices_="cohort_indices_"
      :cycles_="cycles_"
      :periods_="periods_"
      :levels_="levels_"
      :sections_="sections_"
      :student_status_="student_status_"
      :achievement_range_group="selected_achievement_range_group"
    >
    </AssessmentGroupStudyUnitTable>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "AssessmentGroupStudyUnit",
  components: {
    AssessmentGroupStudyUnitTable: () =>
      import(
        "@/components/reports/TeachingReport/AssessmentGroupStudyUnit/AssessmentGroupStudyUnitTable"
      ),
    AchievementRangeGroupSelector: () =>
      import(
        "@/components/reports/TeachingReport/AchievementRangeGroupSelector.vue"
      ),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
    egress_profile_matter: {
      type: Object,
      required: true,
    },
    cohorts_: {
      type: Array,
      required: true,
    },
    cohort_indices_: {
      type: Array,
      default: () => [],
    },
    cycles_: {
      type: Array,
    },
    periods_: {
      type: Array,
    },
    levels_: {
      type: Array,
    },
    sections_: {
      type: Array,
    },
    student_status_: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected_achievement_range_group: null,
      show_assessment_range_table: false,
    };
  },
  computed: {},
  methods: {
    selectedRangeGroup(achievement_range_group_id) {
      this.selected_achievement_range_group = achievement_range_group_id;
      this.show_assessment_range_table = true;
    },
  },
  created() {},
};
</script>

<style scoped>
</style>

